import React, { FC } from 'react';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import { find } from 'lodash';

import { CustomSVG } from 'components';
import { useContent, useQueryParams } from 'hooks';

const styles = (theme: Theme) =>
  createStyles({
    icon: {
      marginRight: theme.spacing(0.5),
      color: theme.palette.primary.main,
    },
  });

const Pin: FC<WithStyles<typeof styles>> = ({ classes }) => {
  const content = useContent();
  const { variables } = useQueryParams();

  function isPinnedToGroup() {
    return !!find(content.pinned_to_groups, ['group_id', variables.id]);
  }

  function isPinned() {
    return content.is_pinned;
  }

  if (!isPinned() && !isPinnedToGroup()) {
    return null;
  }

  return <CustomSVG name="pin" size={16} className={classes.icon} />;
};

export default withStyles(styles)(Pin);
